import React, { useEffect } from 'react';
import { usePropsContext } from '@uhg-abyss/web/hooks/usePropsContext';
import { config } from '@uhg-abyss/web/tools/config';
import { tokenizer } from '@uhg-abyss/web/tools/tokenizer';
import { storage } from '@uhg-abyss/web/tools/storage';
import { LoadingOverlay } from '@uhg-abyss/web/ui/LoadingOverlay';
import { usercache } from '../../../../redux/tools/usercache';
import { useSSO } from '../../../../redux/resources/sso';
import { useUser } from '../../../../redux/resources/user';
import { useNavigate } from 'react-router-dom';

import { TechnicalUserButton } from './TechnicalUserButton';

export const AuthenticateUser = () => {
  const { data, events } = usePropsContext();
  const { user } = useUser.state();
  const { validateUser } = useUser.actions();
  const { userSSO } = useSSO.actions();
  const navigate = useNavigate();
  const queryParams = Object.fromEntries(
    new URLSearchParams(window.location.search)
  );

  const getRedirectUrl = () => {
    const productPath = storage.session.get('productPath');
    const technicalUserURL = config('TECHNICAL_USER_URL');
    const redirectURL = productPath
      ? window.location.href.replace(/#.*$/, `#${productPath}`)
      : window.location.href.replace(/#.*$/, '');
    const encodedTarget = encodeURIComponent(btoa(redirectURL));
    const redirectUrl = `${technicalUserURL}/#/redirect/${encodeURIComponent(
      encodedTarget
    )}`;
    return redirectUrl;
  };

  const handleTechnicalUserRedirect = () => {
    window.location = getRedirectUrl();
  };

  const deleteCookieAndHandleTechnicalUserRedirect = () => {
    const redirect = getRedirectUrl();
    window.location = `/api/identity/ohid/deletecookies?redirect=${redirect}`;
  };

  const handleUserValidate = () => {
    validateUser(
      (response) => {
        if (queryParams.id) {
          navigate('/', { replace: true });
        }
        usercache.set('uuid', response.uuid);
        usercache.set('isIntakeUser', response.isIntakeUser);
        if (response.isTechnicalUser) {
          if (!response.hasTechnicalRole) {
            handleTechnicalUserRedirect();
          } else if (response.technicalRedirectUrl) {
            navigate(response.technicalRedirectUrl);
          }
        }
        events('onSuccess', response);
      },
      (error) => {
        events('onError', error);
      }
    );
  };

  useEffect(() => {
    const tokenData = tokenizer.parse(data.token) || {};
    if (tokenData.username && tokenData.username.includes('-question-')) {
      tokenData.username.replaceAll('-question-', '?');
    }
    if (tokenData.optumId && tokenData.optumId.includes('-question-')) {
      tokenData.optumId.replaceAll('-question-', '?');
    }

    if (tokenData.sso) {
      userSSO(tokenData);
    } else {
      handleUserValidate();
    }
  }, []);

  if (userSSO.saga.isLoading) {
    return <LoadingOverlay isLoading loadingMessage="Loading, please wait." />;
  }
  if (user.isTechnicalUser) {
    return (
      <TechnicalUserButton
        onClick={deleteCookieAndHandleTechnicalUserRedirect}
      />
    );
  }

  return null;
};
